import { GoabDivider, GoabLink, GoabText } from '@abgov/angular-components';
import { idFromRoute } from '@ala/common-ui';
import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CapacityReportStatus } from '@libs/services/graphql/generated/ala-backend.service';
import { Subject, takeUntil } from 'rxjs';
import { CapacityReportListStateService } from '../../../../services-v2/states/capacity-report-list.state.service';
import { FacilityCapacityEntryStateService } from '../../../../services-v2/states/facility-capacity-entry.state.service';
import { FacilityEntryBedRowStateService } from '../../../../services-v2/states/facility-entry-bed-row.state.service';
import { CapacityReportingPeriodPipe } from '../../../../shared/pipes/capacity-reporting-period-v2.pipe';
@Component({
  selector: 'app-facility-reporting-period',
  imports: [
    CommonModule,
    GoabText,
    CapacityReportingPeriodPipe,
    RouterLink,
    GoabLink,
    GoabDivider,
  ],
  templateUrl: './facility-reporting-period.html',
  styleUrl: './facility-reporting-period.scss',
})
export class FacilityReportingPeriod implements OnInit, OnDestroy {
  private readonly _facilityCapacityEntryStateService = inject(
    FacilityCapacityEntryStateService
  );
  private readonly _reportListStateService = inject(
    CapacityReportListStateService
  );
  private readonly _facilityEntryBedRowStateService = inject(
    FacilityEntryBedRowStateService
  );
  public route = inject(ActivatedRoute);
  private readonly destroy$ = new Subject<void>();

  selectedFacilityBeds =
    this._facilityCapacityEntryStateService.selectedFacilityBeds;

  async ngOnInit(): Promise<void> {
    this.route.paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (params) => {
        const { isValid, id } = idFromRoute(params);
        if (isValid && id) {
          this._facilityEntryBedRowStateService.resetToInitialState(); // clear out cached states
          this._facilityCapacityEntryStateService.resetToInitialState(); // clear out cached states
          this._facilityCapacityEntryStateService.setSelectedReportId = id;
          this._facilityCapacityEntryStateService.setDrawerOpenClose = true;
          await this._facilityCapacityEntryStateService.resolveFirstWeekFlagForCurrentFacility(); // Resolve first week report flag
          await this._facilityCapacityEntryStateService
            .loadCapacityReportByFacilityId()
            .then(() => {
              // setup facility beds initially
              this._facilityEntryBedRowStateService.setSelectedReportId = id;
              this._facilityEntryBedRowStateService.setSelectFacilityBedsRows =
                this._facilityCapacityEntryStateService.selectedFacilityBeds()
                  ?.facilityBeds ?? [];
              this._reportListStateService.updateCapacityReportStatus(
                this._facilityCapacityEntryStateService.selectedReportId(),
                this._facilityCapacityEntryStateService.selectedFacilityBeds()
                  ?.status ?? CapacityReportStatus.NOTSTARTED
              );
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
